import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { useTypedLocation } from "src/utils/hooks/useTypedLocation";
import useUser from "src/utils/hooks/useUser";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { navigateToNewStateHash } from "src/utils/location/navigateToNewStateHash";
import Bookmark from "src/design-system/icons/Bookmark.svg?react";
import { Button } from "src/design-system/components/Button/Button";
import ChevronRight from "src/design-system/icons/ChevronRight.svg?react";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import ChevronLeft from "src/design-system/icons/ChevronLeft.svg?react";
import messages from "../TripPlannerScreen.messages";
import { UserAccountTakeover } from "../UserAccountTakeover/UserAccountTakeover";

export function TripSaveButton() {
  const intl = useIntl();
  const [showSigninTakeover, setShowSigninTakeover] = useState(false);
  const navigate = useNavigate();
  const location = useTypedLocation();
  const { user } = useUser();
  const { isMobile } = useScreenMinWidth();

  const isLoggedOut = !user?.id;

  function handleBookmarkClick() {
    setShowSigninTakeover(true);
    sendAnalyticsInteractionEvent({
      category: "TripPlanner",
      action: "Click:SaveTrip:MultipleTrips",
    });
  }

  function handleSavedTrips() {
    navigateToNewStateHash(
      navigate,
      {
        highlightedTab: "trips",
      },
      `#trips/saved/`,
      {
        ...location,
      },
    );
  }

  if (!isLoggedOut)
    return (
      <div className="mb-3 -ml-3">
        <Button onPress={handleSavedTrips} size="small" variant="subtle">
          <ChevronLeft className="md:hidden" />
          <span>{intl.formatMessage(messages.savedTrips)}</span>
          <ChevronRight className="hidden h-4 w-4 text-icon-primary md:inline-block" />
        </Button>
      </div>
    );

  return (
    <div className="flex justify-end">
      <Button
        variant={isMobile ? "secondary" : "primary"}
        data-testid="save-trip-signin-button"
        onPress={handleBookmarkClick}
        className="px-2.5 py-2"
      >
        <Bookmark className="h-4.5 w-4.5 text-icon-primary md:text-white" />
        <span>{intl.formatMessage(messages.save)}</span>
        <UserAccountTakeover
          isDropdownOpen={showSigninTakeover}
          handleClose={() => setShowSigninTakeover(false)}
          handleClickOffDropdown={() => setShowSigninTakeover(false)}
        />
      </Button>
    </div>
  );
}
